// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"d4784b3b","729":"f9e40411","883":"c86c9f23"}[chunkId] + ".chunk.js";
};